/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2023-12-23 11:36:18
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\local\deleter.js
 */
import state from './state'
import localApi from './localapi'
const deleter = {
	delCenterCode() {
		return localApi.removeLocal(state.centerCode)
	},
	delNetworkFlag() {
		return localApi.removeLocal(state.networkFlag)
	},
	delResearchCode() {
		return localApi.removeLocal(state.researchCode)
	},
	delRouteMoreRecord() {
		return localApi.removeLocal(state.routeMoreRecord)
	},
	delUserInfo() {
		return localApi.removeLocal(state.userInfo)
	},
	delUserToken() {
		return localApi.removeLocal(state.userToken)
	},
	delUserAuthority() {
		return localApi.removeLocal(state.userAuthority)
	},
	delIdentityType() {
		return localApi.removeSession(state.identityType)
	},
	delUserOpenId() {
		return localApi.removeLocal(state.userOpenId)
	},
	delTesteeScrollTop() {
		return localApi.removeSession(state.testeeScrollTop)
	},
	delResearchScrollTop() {
		return localApi.removeSession(state.researchScrollTop)
	},
	delTesteePaginationConfig() {
		return localApi.removeLocal(state.testeePaginationConfig)
	},
	delRecruitPaginationConfig() {
		return localApi.removeLocal(state.recruitPaginationConfig)
	}
}
export default deleter
